// extracted by mini-css-extract-plugin
export default {"bundles":"Bundles_bundles__OtEw8"};